import feed1 from './feed1.png';
import feed2 from './feed2.png';
import feed3 from './feed3.png';
import feed4 from './feed4.png';

import * as FeedConfig from 'unitData/Feed/FeedData';

export const getImageFeed = (type: number) => {
  if (type === FeedConfig.feedTypes[0].id) {
    return feed1;
  } else if (type === FeedConfig.feedTypes[1].id) {
    return feed2;
  } else if (type === FeedConfig.feedTypes[2].id) {
    return feed3;
  } else {
    return feed4;
  }
};
